<template xmlns="http://www.w3.org/1999/html">
  <div v-if="authenticatedUser">
    <!-- page main-->
    <main class="creation pt-n5" role="main">
      <div class="container-fluid px-6 mt-n5">
        <div class="row form">
          <!-- left-->
          <!-- left-->
          <div class="col-lg-12 right-modal">
            <div class="wraps">
              <div class="basic-form" id="basic-form" ref="basicform">
                <div class="row">
                  <div class="col">
                    <!-- input-->
                    <div class="mb-3">
                      <label class="form-label" for="exampleFormControlInput1">
                        Ingredient Title<span class="mandatory"
                          >Mandatory</span
                        ></label
                      >
                      <input
                        class="form-control"
                        type="text"
                        id="input-1"
                        placeholder="Enter Ingredient Title"
                        v-model="form.title"
                      />
                      <b-alert
                        dismissible
                        v-model="emptyTitleAlert"
                        variant="danger"
                      >
                        You have to provide a title!
                      </b-alert>
                    </div>
                    <!-- input-->
                    <div class="mb-3">
                      <label class="form-label" for="exampleFormControlInput1">
                        Ingredient Description<span class="mandatory"
                          >Mandatory</span
                        ></label
                      >
                      <textarea
                        class="form-control"
                        id="recipeDescription"
                        placeholder="Enter Ingredient Description"
                        rows="4"
                        v-model="form.description"
                      ></textarea>
                      <b-alert
                        dismissible
                        v-model="emptyDescriptionAlert"
                        variant="danger"
                      >
                        You have to provide a description!
                      </b-alert>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-6">
                    <!-- input-->
                    <div class="mb-3">
                      <label
                        class="form-label mb-n1"
                        for="exampleFormControlInput1"
                      >
                        <span class="w-20">Ingredient Type</span
                        ><span class="mandatory">Mandatory</span></label
                      >
                      <span
                        class="
                          mb-2
                          font-italic font-weight-light
                          text-secondary
                        "
                        >Identify the information the resource-ingredient
                        delivers
                      </span>

                      <select
                        class="multi-select form-select mt-2"
                        aria-label="Default select example"
                        multiple="multiple"
                        data-max-shown="3"
                        id="typemulti"
                      >
                        <option value="CH object">CH object</option>
                        <option value="Co-creation methodologies and tool">
                          Co-creation methodologies and tool
                        </option>
                        <option value="Digital tool">Digital tool</option>
                        <option value="Impact assessment tool">
                          Impact assessment tool
                        </option>
                        <option value="Past project">Past project</option>
                        <option value="Physical tool">Physical tool</option>
                        <option value="Policy about CH">Policy about CH</option>
                        <option value="Policy about migration">
                          Policy about migration
                        </option>
                        <option value="Training material">
                          Training material
                        </option>
                        <option value="User needs resource">
                          User needs resource
                        </option>
                        <option value="Other">Other</option>
                      </select>

                      <div
                        class="specify"
                        v-if="form.resourceType.includes('Other')"
                      >
                        <label
                          class="form-label"
                          for="exampleFormControlInput1"
                        >
                          Please Specify</label
                        >
                        <b-form-input
                          class="form-control"
                          type="text"
                          placeholder="Enter the type area of the ingredient"
                          v-model="additionalType"
                        />
                      </div>
                      <b-alert
                        dismissible
                        v-model="emptyTypeAlert"
                        variant="danger"
                      >
                        You have to provide a type!
                      </b-alert>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <!-- input-->
                    <div class="mb-3">
                      <label
                        class="form-label mb-n1"
                        for="exampleFormControlInput1"
                      >
                        <span class="w-20">Areas of Focus</span></label
                      >
                      <span
                        class="
                          mb-2
                          font-italic font-weight-light
                          text-secondary
                        "
                        >Topics addressed by the resource material
                      </span>
                      <select
                        class="multi-select form-select"
                        aria-label="Default select example"
                        multiple="multiple"
                        data-max-shown="3"
                        id="focusmulti-modal"
                      >
                        <option value="Arts and heritage">
                          Arts and heritage
                        </option>
                        <option value="Community development">
                          Community development
                        </option>
                        <option value="Education">Education</option>
                        <option value="Human rights">Human rights</option>
                        <option value="Intercultural understanding">
                          Intercultural understanding
                        </option>
                        <option value="Interreligious understanding">
                          Interreligious understanding
                        </option>
                        <option value="Job placement/employment">
                          Job placement/employment
                        </option>
                        <option value="Leisure and entertainment">
                          Leisure and entertainment
                        </option>
                        <option value="Skills development">
                          Skills development
                        </option>
                        <option value="Social inclusion">
                          Social inclusion
                        </option>
                        <option value="Other">Other</option>
                      </select>
                      <div
                        class="specify"
                        v-if="selectedFocusAreas.includes('Other')"
                      >
                        <label
                          class="form-label"
                          for="exampleFormControlInput1"
                        >
                          Please Specify</label
                        >
                        <b-form-input
                          class="form-control"
                          type="text"
                          placeholder="Enter the focus area of the ingredient"
                          v-model="additionalFocusArea"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-6">
                    <!-- input-->
                    <div class="mb-3">
                      <label
                        class="form-label mb-n1"
                        for="exampleFormControlInput1"
                      >
                        <span class="w-20">Ingredient Visibility </span></label
                      >
                      <span
                        class="
                          mb-2
                          font-italic font-weight-light
                          text-secondary
                        "
                        >Define who can see your ingredient
                      </span>
                      <select
                        class="form-select"
                        aria-label="Default select example"
                        v-model="form.publicReadable"
                        @change="visibilityChanged"
                      >
                        <option value="" selected disabled>
                          Select visibility
                        </option>

                        <option
                          title="Only users with whom the ingredient has been shared can access it"
                          value="Private"
                        >
                          Private
                        </option>
                        <option
                          title="All users can view this ingredient"
                          value="Public"
                        >
                          Public
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <!-- keyword-->
                    <div class="mb-3">
                      <label
                        class="form-label mb-n1"
                        for="exampleFormControlInput1"
                      >
                        <span class="w-20">
                          Tags (Press Enter after each keyword)
                        </span></label
                      >
                      <span
                        class="
                          mb-2
                          font-italic font-weight-light
                          text-secondary
                        "
                        >Keywords that capture important aspects of the
                        ingredient
                      </span>
                      <tags-input
                        :typeahead="true"
                        element-id="keywords"
                        v-model="form.keywords"
                        type="text"
                      />
                      <!-- </div> -->
                    </div>
                  </div>
                </div>
              </div>
              <div class="advanced-form" id="advanced-form">
                <div class="row">
                  <div class="col-lg-6">
                    <!-- input-->
                    <div class="mb-3">
                      <label class="form-label" for="exampleFormControlInput1">
                        Upload ingredient content</label
                      >
                      <input
                        class="form-control h-100"
                        type="file"
                        :state="Boolean(file)"
                        placeholder="Browse your file"
                        @change="fileChanged($event)"
                      />
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <!-- input-->
                    <div class="mb-3">
                      <label class="form-label" for="exampleFormControlInput1">
                        <span class="instruction">or enter a </span>URL from an
                        external source</label
                      >
                      <input
                        class="form-control h-100"
                        type="text"
                        placeholder="Enter ingredient title"
                        v-model="form.url"
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-6">
                    <!-- input-->
                    <div class="mb-3">
                      <label class="form-label" for="exampleFormControlInput1">
                        Media Type<span class="mandatory"
                          >Mandatory</span
                        ></label
                      >
                      <select
                        class="form-select"
                        aria-label="Default select example"
                        id="ingredientMediaType"
                        v-model="form.mediaType"
                      >
                        <option value="" selected>Select media type</option>
                        <option
                          v-for="mediaType in definedMediaTypes"
                          :value="mediaType.label"
                          :key="mediaType.label"
                        >
                          {{ mediaType.label }}
                        </option>
                      </select>
                      <b-alert
                        dismissible
                        v-model="emptyMediaTypeAlert"
                        variant="danger"
                      >
                        Cannot be empty!
                      </b-alert>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-6">
                    <!-- input-->
                    <div class="mb-3">
                      <label
                        class="form-label mb-n1"
                        for="exampleFormControlInput1"
                      >
                        <span class="w-20"> Languages</span></label
                      >
                      <span
                        class="
                          mb-2
                          font-italic font-weight-light
                          text-secondary
                        "
                        >Language of the ingredient's content, if relevant
                      </span>
                      <select
                        class="multi-select form-select"
                        aria-label="Default select example"
                        multiple="multiple"
                        data-max-shown="3"
                        id="languagemulti-modal"
                      >
                        <option value="Arabic">Arabic</option>
                        <option value="Chinese">Chinese</option>
                        <option value="English">English</option>
                        <option value="Finnish">Finnish</option>
                        <option value="French">French</option>
                        <option value="German">German</option>
                        <option value="Greek">Greek</option>
                        <option value="Italian">Italian</option>
                        <option value="Spanish">Spanish</option>
                        <option value="Other">Other (specify)</option>
                      </select>
                      <div
                        class="specify"
                        v-if="form.contentLanguage.includes('Other')"
                      >
                        <label
                          class="form-label"
                          for="exampleFormControlInput1"
                        >
                          Please Specify</label
                        >
                        <b-form-input
                          class="form-control"
                          type="text"
                          placeholder="Enter the language of the ingredient"
                          v-model="additionalLanguage"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <!-- input-->
                    <div class="mb-3">
                      <label
                        class="form-label mb-n1"
                        for="exampleFormControlInput1"
                      >
                        <span class="w-20"> License</span
                        ><span class="mandatory">Mandatory</span></label
                      >
                      <div
                        class="

                          font-italic font-weight-light
                          text-secondary
                        "
                      >
                        Choose a
                        <a
                          href="https://creativecommons.org/licenses/"
                          rel="noopener noreferrer"
                          target="_blank"
                          >Creative Commons</a
                        >
                        license or specify other
                      </div>
                      <select
                        class="form-select"
                        aria-label="Default select example"
                        v-model="form.ingredientLicenseField"
                        @change="licenseChanged"
                      >
                        <option value="" selected disabled>
                          Select license that applied to the content
                        </option>
                        <option
                          v-for="lic in licenses"
                          :value="lic.title"
                          :title="lic.desc"
                          :key="lic.title"
                        >
                          {{ lic.title }}
                        </option>
                      </select>
                      <b-form-group
                        class="mt-2"
                        v-if="form.ingredientLicenseField === 'Other'"
                      >
                        <label class="d-block text-left text-bold"
                          >Please specify</label
                        >
                        <b-form-input
                          placeholder="Enter the license of the ingredient"
                          v-model="additionalLicense"
                        >
                        </b-form-input>
                      </b-form-group>
                      <b-alert
                        dismissible
                        v-model="emptyAdditionalLicenseAlert"
                        variant="danger"
                      >
                        You have to specify your license!
                      </b-alert>
                      <b-alert
                        dismissible
                        v-model="emptyIngredientLicenseAlert"
                        variant="danger"
                      >
                        Cannot be empty!
                      </b-alert>
                    </div>
                  </div>
                </div>
                <div class="heading">
                  <h2>Creators</h2>
                  <ul class="actionmenu-modal">
                    <li class="prime">
                      <a
                        title="Describe the organization who has produced this ingredient as part of the ingredient description"
                        v-b-tooltip.hover.top
                        href="javascript:void(0)"
                        @click.prevent="addNewNonExistingCreator"
                        ><i class="fas fa-plus"></i> Add New Creator</a
                      >
                    </li>
                    <li class="prime">
                      <a
                        href="javascript:void(0)"
                        @click="searchForCollaborator()"
                        title="Search for an existing organisation registered in the platform and add it as a creator."
                        v-b-tooltip.hover.bottom
                        ><i class="fas fa-plus"></i> Add Existing Creator</a
                      >
                    </li>
                  </ul>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="empty">
                      <p
                        v-if="
                          creators.length === 0 &&
                          chosenCreators.length === 0
                        "
                      >
                        No Creators added yet. Please mention the organisations
                        involved in producing the content of this ingredient.
                      </p>
                    </div>
                    <div>
                      <div
                        class="element-item"
                        v-for="(col, index) in chosenCreators"
                        :key="col.id"
                      >
                        <div class="row">
                          <div class="col-lg-1 col-sm-1 ic">
                            <img src="../../assets/ic-collaborator.png" />
                          </div>
                          <div class="col-lg-10 col-sm-10">
                            <a title="">
                              <h2>{{ col.name }}</h2></a
                            >
                            <p>
                              {{ col.description }}
                            </p>
                            <span class="typelocation">{{
                              col.type.toString()
                            }}</span>
                          </div>
                          <div class="col-lg-1 col-sm-1 action">
                            <ul>
                              <li>
                                <a
                                  class="delete"
                                  href="javascript:void(0)"
                                  @click="deleteCollaborator(index)"
                                  title="Delete this creator"
                                  ><i class="far fa-trash-alt"></i
                                ></a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <hr
                        v-if="
                          (creators.length === 0 &&
                            chosenCreators.length === 0) ||
                          chosenCreators.length !== 0
                        "
                      />
                      <b-row
                        :key="index"
                        class="mt-3 col-12"
                        v-for="(creator, index) in creators"
                      >
                        <div class="element-item manual" id="add-creator-form">
                          <div class="row">
                            <div class="col-lg-1 col-sm-1 ic">
                              <img src="../../assets/ic-collaborator.png" />
                            </div>
                            <div class="col-lg-10 col-sm-10">
                              <div class="row">
                                <div class="col-sm-12">
                                  <div class="mb-3">
                                    <input
                                      class="form-control"
                                      type="text"
                                      placeholder="Enter creator name"
                                      v-model="creators[index].name"
                                    />
                                  </div>
                                </div>
                                <div class="col-sm-12">
                                  <div class="mb-3">
                                    <select
                                      class="form-select"
                                      aria-label="Default select example"
                                      v-model="creators[index].type"
                                    >
                                      <option value="" selected disabled>
                                        Select creator type
                                      </option>
                                      <option value="Central government">
                                        Central government
                                      </option>
                                      <option value="Charity or foundation">
                                        Charity or foundation
                                      </option>
                                      <option value="For-profit organisation">
                                        For-profit organisation
                                      </option>
                                      <option value="GLAM">GLAM</option>
                                      <option
                                        value="Informal group or association"
                                      >
                                        Informal group or association
                                      </option>
                                      <option value="International body">
                                        International body
                                      </option>
                                      <option value="Local government">
                                        Local government
                                      </option>
                                      <option
                                        value="Non-Governmental Organisation"
                                      >
                                        Non-Governmental Organisation
                                      </option>
                                      <option value="Regional government">
                                        Regional government
                                      </option>
                                      <option value="Religious institutions">
                                        Religious institutions
                                      </option>
                                      <option value="School">School</option>
                                      <option value="Other">Other</option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-lg-1 col-sm-1 action">
                              <ul>
                                <li>
                                  <a
                                    @click="deleteNonExistingCreator(index)"
                                    class="delete"
                                    href="javascript:void(0)"
                                    title="Delete this creator"
                                    ><i class="far fa-trash-alt"></i
                                  ></a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </b-row>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- left-->
      <!-- action-->
      <ul class="ul-modal">
        <li><a class="orange-modal" href="#" @click="checkForm">Save</a></li>
        <li @click="hideModal" class="cancel-modal"><a href="#">Cancel</a></li>
      </ul>
    </main>
  </div>
  <div v-else>
    <NoAccess />
  </div>
</template>

<script>
import SearchPlugin from "../../plugins/SearchPlugin";
import { mapGetters } from "vuex";
import { eventBus } from "../../main";
import axios from "axios";
import NoAccess from "../NoAccess";
import CreateNewOrganization from "../organizations/CreateNewOrganization";
import "../../assets/css/culturelabs.css";
import { mediaTypes } from "../../data.js";
import "vue-slick-carousel/dist/vue-slick-carousel.css";

export default {
  data() {
    return {
      CC_BY:
        "Attribution: This license lets others distribute, remix, adapt, and build upon your work, even commercially, as long as they credit you for the original creation. This is the most accommodating of licenses offered. Recommended for maximum dissemination and use of licensed materials.",
      CC_BY_SA:
        "Attribution-ShareAlike: This license lets others remix, adapt, and build upon your work even for commercial purposes, as long as they credit you and license their new creations under the identical terms. This license is often compared to “copyleft” free and open source software licenses. All new works based on yours will carry the same license, so any derivatives will also allow commercial use.",
      CC_BY_ND:
        "Attribution-NoDerivs: This license lets others reuse the work for any purpose, including commercially; however, it cannot be shared with others in adapted form, and credit must be provided to you.",
      CC_BY_NC:
        "Attribution-NonCommercial: This license lets others remix, adapt, and build upon your work non-commercially, and although their new works must also acknowledge you and be non-commercial, they don’t have to license their derivative works on the same terms.",
      CC_BY_NC_SA:
        "Attribution-NonCommercial-ShareAlike: This license lets others remix, adapt, and build upon your work non-commercially, as long as they credit you and license their new creations under the identical terms.",
      CC_BY_NC_ND:
        "Attribution-NonCommercial-NoDerivs: This license is the most restrictive of our six main licenses, only allowing others to download your works and share them with others as long as they credit you, but they can’t change them in any way or use them commercially.",
      licenses: [
        {
          title: "CC BY",
          desc: "Attribution: This license lets others distribute, remix, adapt, and build upon your work, even commercially, as long as they credit you for the original creation. This is the most accommodating of licenses offered. Recommended for maximum dissemination and use of licensed materials.",
        },
        {
          title: "CC BY-SA",
          desc: "Attribution-ShareAlike: This license lets others remix, adapt, and build upon your work even for commercial purposes, as long as they credit you and license their new creations under the identical terms. This license is often compared to “copyleft” free and open source software licenses. All new works based on yours will carry the same license, so any derivatives will also allow commercial use.",
        },
        {
          title: "CC BY-ND",
          desc: "Attribution-NoDerivs: This license lets others reuse the work for any purpose, including commercially; however, it cannot be shared with others in adapted form, and credit must be provided to you.",
        },
        {
          title: "CC BY-NC",
          desc: "Attribution-NonCommercial: This license lets others remix, adapt, and build upon your work non-commercially, and although their new works must also acknowledge you and be non-commercial, they don’t have to license their derivative works on the same terms.",
        },
        {
          title: "CC BY-NC-SA",
          desc: "Attribution-NonCommercial-ShareAlike: This license lets others remix, adapt, and build upon your work non-commercially, as long as they credit you and license their new creations under the identical terms.",
        },
        {
          title: "CC BY-NC-ND",
          desc: "Attribution-NonCommercial-NoDerivs: This license is the most restrictive of our six main licenses, only allowing others to download your works and share them with others as long as they credit you, but they can’t change them in any way or use them commercially.",
        },
        {
          title: "Other",
          desc: "",
        },
      ],
      definedMediaTypes: mediaTypes,
      modalOrgShow: false,
      file: null,
      collaboratorsExist: false,
      saveAction: false,
      chosenCreators: [],
      chosenCreatorName: [],
      chosenCreatorType: [],
      resourceCollaborators: {},
      resourceCollaboratorsArray: [],
      withUrl: "",
      wotifyUrl: "",
      wotifyProjectId: "",
      availableWotifyProjects: [],
      showDismissibleAlert: false,
      emptyTitleAlert: false,
      emptyAdditionalLicense: false,
      emptyDescriptionAlert: false,
      emptyMediaTypeAlert: false,
      emptyAdditionalLicenseAlert: false,
      emptyIngredientLicenseAlert: false,
      emptyResourceTypeAlert: false,
      emptyAdditionalResourceType: false,
      emptyAdditionalTypeAlert: false,
      isEditable: true,
      // emptySelectedFocusAreasAlert: false,
      emptyTypeAlert: false,

      selectedFocusAreas: [], // Must be an array reference!
      selectedFocusAreas2: [], // Must be an array reference!
      publicReadable: false,
      withCollection: false,
      //withCollectionUrl:'',
      withToken: "",
      wotifyDashboard: false,
      wotifyToken: "",
      additionalFocusArea: "",
      additionalLanguage: "",
      additionalLicense: "",
      additionalType: "",
      sTerm: "", // Search integration addition
      FocusAreaOptions: [
        { text: "Arts and heritage", value: "Arts and heritage" },
        { text: "Community development", value: "Community development" },
        { text: "Education", value: "Education" },
        { text: "Human rights", value: "Human rights" },
        {
          text: "Intercultural understanding",
          value: "Intercultural understanding",
        },
        {
          text: "Interreligious understanding",
          value: "Interreligious understanding",
        },
        { text: "Job placement/employment", value: "Job placement/employment" },
        {
          text: "Leisure and entertainment",
          value: "Leisure and entertainment",
        },
        { text: "Skills development", value: "Skills development" },
        { text: "Social inclusion", value: "Social inclusion" },
        { text: "Other (specify)", value: "Other" },
      ],
      selectedKeywords: [],
      loaded: true,
      form: {
        title: "",
        description: "",
        notes: "",
        license: [],
        url: "",
        thumbnailUrl: "",
        mediaType: "",
        contentLanguage: [],
        resourceType: [],
        ingredientLicense: [],
        ingredientLicenseField: "",
        publicReadable: "",
        withCollection: false,
        withCollectionUrl: "",
        wotifyDashboard: false,
        keywords: [],
      },
      collaborators: [{ id: 0 }],
      creatorsWithId: [{ id: 0 }],
      creators: [],
      withIframe: {
        src: `${process.env.WITH_URL}/login`,
        loaded: false,
      },
      wotifyIframe: {
        src: `${process.env.WOTIFY_URL}/embed/login`,
        loaded: false,
      },
    };
  },

  beforeRouteLeave(to, from, next) {
    if (!this.saveAction && this.authenticatedUser) {
      this.boxOne = "";
      let message =
        "Are you sure you want to leave without saving? If you do, all your work will be lost.";
      this.$bvModal
        .msgBoxConfirm(message, {
          title: "Warning",
          okVariant: "danger",
        })
        .then((value) => {
          this.boxOne = value;
          if (this.boxOne) {
            next();
          } else {
            next(false);
          }
        });
    } else {
      next();
    }
  },
  created() {
    eventBus.$on("hideOrgModal", (hideOrgModal) => {
      this.modalOrgShow = hideOrgModal;
    });
    eventBus.$on("organizationTitle", (organizationTitle) => {
      this.chosenCreatorName.push(organizationTitle);
    });
    eventBus.$on("organizationObject", (organizationObject) => {
      this.chosenCreators.push(organizationObject);
    });
    eventBus.$on("organizationId", (organizationId) => {
      this.resourceCollaborators["id"] = organizationId;
      this.resourceCollaboratorsArray.push(this.resourceCollaborators);
      this.resourceCollaborators = {};
    });
  },
  components: {
    NoAccess,
    CreateNewOrganization,
  },
  computed: {
    ...mapGetters(["authenticatedUser"]),
    FocusM() {
      let FocusM = this.selectedFocusAreas;
      return FocusM;
    },
    publicReadableVal() {
      let publicReadableVal = false;
      if (this.form.publicReadable) {
        publicReadableVal = true;
      }
      if (this.form.publicReadable === undefined) {
        publicReadableVal = false;
      }
      return publicReadableVal;
    },
    isWithCollection() {
      this.updateWithContent();
      return this.withCollection ? true : false;
    },
    withTokenFound() {
      return this.withToken.length > 0 ? true : false;
    },
    isWotifyDashboard() {
      this.updateWotifyContent();
      return this.wotifyDashboard ? true : false;
    },
    wotifyTokenFound() {
      return this.wotifyToken.length > 0 ? true : false;
    },
    NewKeywordsArray() {
      let NewKeywordsArray = [];
      for (let i = 0; i < this.form.keywords.length; i++) {
        NewKeywordsArray.push(this.form.keywords[i].value);
      }
      return NewKeywordsArray;
    },
    currentWotifyProject() {
      let project = this.availableWotifyProjects.find(
        (p) => p._id == this.wotifyProjectId
      );
      return project ? project : false;
    },
  },
  beforeMount() {
    SearchPlugin.event.$on("updateterm", this.changeTerm);
    SearchPlugin.event.$on("showView", this.showView);
  },
  mounted() {
    window.addEventListener("message", this.receiveMessage);
    this.withUrl = process.env.WITH_URL;
    this.wotifyUrl = process.env.WOTIFY_URL;
    $("#languagemulti-modal").multiselect({
      onChange: this.languageChanged,
    });
    $("#languagemulti-modal").multiselect("refresh");

    $("#typemulti").multiselect({
      onChange: this.ingredientTypeChanged,
    });
    $("#typemulti").multiselect("refresh");
    $("#focusmulti-modal").multiselect({
      onChange: this.focusAreasChanged,
    });
    $("#focusmulti-modal").multiselect("refresh");
  },
  beforeDestroy() {
    window.removeEventListener("message", this.receiveMessage);
  },
  methods: {
    scrollTo(refName, e) {
      let element = this.$refs[refName];
      let top = element.offsetTop;
      window.scrollTo({
        top: top,
        left: 0,
        behavior: "smooth",
      });
      $(".active").removeClass("active");
      e.currentTarget.classList.toggle("active");
    },
    licenseChanged() {
      this.form.ingredientLicense = this.form.ingredientLicenseField;
    },
    languageChanged: function () {
      this.form.contentLanguage =
        $("#languagemulti-modal").val() === null
          ? []
          : $("#languagemulti-modal").val();
    },
    ingredientTypeChanged: function () {
      this.form.resourceType =
        $("#typemulti").val() === null ? [] : $("#typemulti").val();
    },
    focusAreasChanged: function () {
      this.selectedFocusAreas =
        $("#focusmulti-modal").val() === null
          ? []
          : $("#focusmulti-modal").val();
    },
    fileChanged(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.file = files[0];
    },
    withLoad() {
      this.withIframe.loaded = true;
    },
    wotifyLoad() {
      this.wotifyIframe.loaded = true;
    },
    openExternal(url) {
      var tabOrWindow = window.open(url, "_blank");
      tabOrWindow.focus();
    },
    loadDashboard(id) {
      var url = this.wotifyUrl + "/projects/" + id;
      var tabOrWindow = window.open(url, "_blank");
      tabOrWindow.focus();
    },
    receiveMessage(msg) {
      console.log("receiveMessage", msg);
      if (typeof msg.data === "string") {
        if (msg.data.startsWith("withtoken") && this.withToken.length == 0) {
          // Store the token and use it
          this.$root.$emit("bv::hide::modal", "withModal");
          this.withToken = msg.data.split(" ")[1];
          console.log("WITHTOKEN:" + this.withToken);
        }
        if (
          msg.data.startsWith("wotifyToken") &&
          this.wotifyToken.length == 0
        ) {
          // Store the token and use it
          this.$root.$emit("bv::hide::modal", "wotifyModal");
          this.wotifyToken = msg.data.split(" ")[1];
          console.log("WOTIFYTOKEN:" + this.wotifyToken);
          // populate existing projects
          fetch(process.env.WOTIFY_API_URL + "/projects?include_empty", {
            headers: { Authorization: "Bearer " + this.wotifyToken },
          })
            .then((response) => response.json())
            .then((data) => {
              this.availableWotifyProjects = data;
            })
            .catch((error) => {
              console.error("failed wotify fetch", error);
              this.showMsgFail(error);
            });
        }
      }
      return;
    },

    initializeCollaborators() {
      this.creatorsWithId = [{ id: 0 }];
      thiscollaboratorsExist = true;
    },

    // To be checked
    visibilityChanged() {
      if (this.form.publicReadable === "Public") {
        this.publicReadable = true;
      } else {
        this.publicReadable = false;
      }
    },
    updateWithContent() {
      if (this.withCollection) {
        this.form.resourceType = [];
        this.form.resourceType.push("CH object");
        this.form.mediaType = "WithCulture Collection";
        this.form.ingredientLicense = [];
        this.form.ingredientLicense = "CC BY";
        this.form.url = "";
        this.form.withCollectionUrl = "";
      } else {
        this.form.resourceType = [];
        this.form.ingredientLicense = [];
        this.form.url = "";
        this.form.mediaType = "";
      }
    },
    updateWotifyContent() {
      this.form.resourceType = [];
      this.form.ingredientLicense = [];
      this.form.url = "";
      this.form.mediaType = "";
      if (this.wotifyDashboard) {
        this.form.resourceType.push("Co-creation methodologies and tool");
        this.form.mediaType = "Wotify Board";
        this.form.ingredientLicense = "CC BY";
        if (this.currentWotifyProject) {
          this.form.url = this.wotifyUrl + "/projects/" + this.wotifyProjectId;
          this.form.title = this.currentWotifyProject.title;
          this.form.description = this.currentWotifyProject.description;
        }
      }
    },
    searchForCollaborator(index) {
      eventBus.$emit("forgetGlobalSearch", null);
      this.searchCategory("Organisations");
    },
    checkForm() {
      // Re-initialize alerts in case the user tries again
      this.showDismissibleAlert = false;
      this.emptyTitleAlert = false;
      this.emptyDescriptionAlert = false;
      this.emptyMediaTypeAlert = false;
      this.emptyIngredientLicenseAlert = false;
      this.emptyResourceTypeAlert = false;
      this.selectedFocusAreas =
        $("#focusmulti-modal").val() === null
          ? []
          : $("#focusmulti-modal").val();
      this.emptyAdditionalLicense = false;
      // this.form.ingredientLicense - this.form.ingredientLicense
      this.emptyTypeAlert = false;

      // Additional Language handle
      if (
        this.form.contentLanguage.includes("Other") &&
        this.form.contentLanguage[this.form.contentLanguage.length - 1] !==
          this.additionalLanguage
      ) {
        if (this.additionalLanguage !== "") {
          this.form.contentLanguage.push(this.additionalLanguage);
        } else {
          this.form.contentLanguage.splice(
            this.form.contentLanguage.indexOf("Other"),
            1
          );
        }
      }
      $("#languagemulti-modal").val(this.form.contentLanguage);
      $("#languagemulti-modal").multiselect("refresh");

      // Additional License handle
      this.form.ingredientLicense = this.form.ingredientLicenseField;
      if (this.form.ingredientLicense === "Other") {
        if (this.additionalLicense !== "") {
          this.form.ingredientLicense = this.additionalLicense;
        } else {
          this.form.ingredientLicense = "";
          this.emptyAdditionalLicense = true;
        }
      }

      if (
        this.selectedFocusAreas.includes("Other") &&
        this.selectedFocusAreas[this.selectedFocusAreas.length - 1] !==
          this.additionalFocusArea
      ) {
        if (this.additionalFocusArea !== "") {
          this.selectedFocusAreas.push(this.additionalFocusArea);
        } else {
          this.selectedFocusAreas.splice(
            this.selectedFocusAreas.indexOf("Other"),
            1
          );
        }
      }
      $("#focusmulti-modal").val(this.selectedFocusAreas);
      $("#focusmulti-modal").multiselect("refresh");

      // Additional Type handle
      if (
        this.form.resourceType.includes("Other") &&
        this.form.resourceType[this.form.resourceType.length - 1] !==
          this.additionalType
      ) {
        if (this.additionalType !== "") {
          this.form.resourceType.push(this.additionalType);
        } else {
          if (this.form.resourceType.length === 1) {
            this.emptyTypeAlert = true;
          } else {
            this.form.resourceType.splice(
              this.form.resourceType.indexOf("Other"),
              1
            );
          }
        }
      }
      $("#typemult").val(this.resourceType);
      $("#typemulti").multiselect("refresh");

      // Creators without ID handle
      for (let i = 0; i < this.creators.length; i++) {
        if (!this.creators[i].name && !this.creators[i].description) {
          this.creators.splice(i, 1);
          i--;
        }
      }

      // check if all required fields are filled
      if (
        !this.form.title ||
        !this.form.description ||
        !this.form.mediaType ||
        this.form.ingredientLicense.length === 0 ||
        this.form.resourceType.length === 0 ||
        this.emptyTypeAlert
      ) {
        this.showDismissibleAlert = true;
        if (!this.form.title) {
          this.emptyTitleAlert = true;
        }
        if (!this.form.description) {
          this.emptyDescriptionAlert = true;
        }
        if (!this.form.mediaType) {
          this.emptyMediaTypeAlert = true;
        }
        if (this.form.ingredientLicense.length === 0) {
          this.emptyIngredientLicenseAlert = true;
        }
        if (
          this.form.ingredientLicense.length !== 0 &&
          this.emptyAdditionalLicense
        ) {
          this.emptyAdditionalLicenseAlert = true;
        }

        if (this.form.resourceType.length === 0) {
          this.emptyTypeAlert = true;
        }
      } else {
        this.registerResource();
      }
    },
    showMsgSuccess() {
      this.boxOne = "";

      this.$bvModal
        .msgBoxOk("Your ingredient has been successfully updated.", {
          okVariant: "success",
        })
        .then((value) => {
          this.boxOne = value;
          if (this.boxOne) {
            eventBus.$emit("hideModal", this.showModal);
          }
        });
    },
    showMsgFail(errorText) {
      this.boxOne = "";
      let errormsg = errorText ? errorText : "";
      this.$bvModal
        .msgBoxOk("Something went wrong. Please try again. " + errormsg, {
          okVariant: "danger",
        })
        .then((value) => {
          this.boxOne = value;
          if (this.boxOne) {
            // window.location.reload()
          } else {
          }
        });
      // .catch(error => {
      //   alert('An error occurred! Please refresh the page.' + error)
      // })
    },
    deleteCollaborator(index) {
      this.creatorsWithId.splice(index, 1);
      this.resourceCollaboratorsArray.splice(index, 1);
      this.chosenCreators.splice(index, 1);
      this.chosenCreatorName.splice(index, 1);
      this.chosenCreatorType.splice(index, 1);
    },
    addNewCollaboratorForm() {
      this.creatorsWithId.push({});
    },
    addNewNonExistingCreator() {
      this.creators.push({
        type: "",
      });
    },
    deleteNonExistingCreator(index) {
      this.creators.splice(index, 1);
    },
    async registerResource() {
      // Register the resource using the API
      this.saveAction = true;
      let postData = {};
      let license = [];
      license.push(this.form.ingredientLicense);
      let InputResourceData = {
        creatorsWithId: this.resourceCollaboratorsArray,
        creators: this.creators,
        title: this.form.title,
        publicReadable: this.publicReadable,
        withCollection: this.withCollection,
        wotifyDashboard: this.wotifyDashboard,
        description: this.form.description,
        metadataLanguage: "string",
        areasOfFocus: this.FocusM,
        notes: this.form.notes,
        keywords: this.NewKeywordsArray,
        mediaType: this.form.mediaType,
        license: license,
        contentLanguage: this.form.contentLanguage,
        mimeType: "string",
        resourceType: this.form.resourceType,
        url: this.form.url,
        thumbnailUrl: this.form.thumbnailUrl,
      };
      this.$store
        .dispatch("createResource", InputResourceData)
        .then((resource) => {
          if (resource) {
            // Create the resource and then, upload the content if the file exists
            if (this.file !== null) {
              let formData = new FormData();
              formData.append("file", this.file);
              let params = { id: resource.id, file: formData };
              this.$store
                .dispatch("uploadResourceContent", params)
                .then((data) => {
                  this.showMsgSuccess();
                  eventBus.$emit("resourceTitle", resource.title);
                  eventBus.$emit("resourceId", resource.id);
                })
                .catch((error) => {
                  console.info(error);
                  this.showMsgFail();
                });
            } else {
              this.showMsgSuccess();
              eventBus.$emit("resourceTitle", resource.title);
              eventBus.$emit("resourceId", resource.id);
            }
          } else {
            this.showMsgFail();
          }
        })
        .catch((error) => {
          console.info(error);
          this.showMsgFail();
        });
    },
    hideModal() {
      eventBus.$emit("hideModal", this.showModal);
    },
    GoAway() {
      this.$store.dispatch("logout");
    },
    changeTerm(val) {
      this.sTerm = val;
    },
    showAll: function (token) {
      this.$search.searchNow();
    },
    showSearch: function () {
      this.$search.toggleSearch();
    },
    initOrg: function () {
      this.organisation = {};
    },
    showView: function (event) {
      this.$store
        .dispatch("getOrganizationEntity", event.detail.id)
        .then((data) => {
          this.initOrg();
          this.organisation = data;
          this.chosenCreators.push(this.organisation);
          if (this.resourceCollaboratorsArray[this.position] == null) {
            this.chosenCreatorName.push(this.organisation.name);
            this.chosenCreatorType.push(this.organisation.type);
            this.resourceCollaborators["id"] = event.detail.id;
            this.resourceCollaboratorsArray.push(this.resourceCollaborators);
            this.resourceCollaborators = {};
          } else {
            this.resourceCollaboratorsArray.splice(this.position, 1);
            this.chosenCreatorName.splice(
              this.position,
              1,
              this.organisation.name
            );
            this.chosenCreatorType.splice(
              this.position,
              1,
              this.organisation.type
            );
            // this.chosenCreatorName.push(this.organisation.name)
            // this.chosenCreatorType.push(this.organisation.type)
            this.resourceCollaborators["id"] = event.detail.id;
            this.resourceCollaboratorsArray.push(this.resourceCollaborators);
            this.resourceCollaborators = {};
          }
        })
        .catch((error) => {
          console.info(error);
        });
    },
    searchCategory: function (cat_type, token) {
      this.$search.searchNow({
        resulttype: cat_type,
        token: token,
      });
    },
    searchTerm: function (term, resulttype, token) {
      this.$search.searchNow({
        term: term,
        resulttype: resulttype,
        token: token,
      });
    },
  },
};
</script>


<style module>
</style>



// WEBPACK FOOTER //
// src/components/resources/CreateNewIngredient.vue